import { render, staticRenderFns } from "./GerenciadorBusca.vue?vue&type=template&id=54387219&scoped=true&"
import script from "./GerenciadorBusca.vue?vue&type=script&lang=js&"
export * from "./GerenciadorBusca.vue?vue&type=script&lang=js&"
import style0 from "./GerenciadorBusca.vue?vue&type=style&index=0&id=54387219&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54387219",
  null
  
)

export default component.exports